<h2 mat-dialog-title>{{ data.title || 'Confirm' }}</h2>
<mat-dialog-content>
  <p><strong>{{ data.message }}</strong></p>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button class="btn btn-sm mb-3" [ngClass]="'btn-primary'" type="button" (click)="onCancel()">
    {{data.cancelText}}
  </button>
  <button class="btn btn-sm mb-3" type="button" [ngClass]="'btn-primary'" (click)="onConfirm()">
    {{ data.confirmText }}
  </button>
</mat-dialog-actions>